import { DayAndTimeSelect } from "@shared/common/components/DayAndTimeSelect";
import { TimeSlider } from "./TimeSlider/TimeSlider";

export function BottomMenu(): React.JSX.Element {
  return (
    <div className="order-3 flex h-18 w-full items-center justify-between gap-m border-t border-subtle px-m py-0">
      <TimeSlider />
      <DayAndTimeSelect showNavigateButtons={true} />
    </div>
  );
}
